/** Filter for editable page. Currently only page and song */

import { isPage } from '@tunasong/schemas'
import { isSong } from '@tunasong/schemas'
import { matchAny } from './filters.js'

export const isEditablePage = matchAny(isSong, isPage)
